export default "__VITE_ASSET__BA$w8dAT__"